import React from 'react';
import PropTypes from 'prop-types';
import LoadingIndicator from '../LoadingIndicator';
import styles from './LoadingOverlay.module.css';

function LoadingOverlay({ status }) {
  return (
    <div className={styles.LoadingOverlay}>
      <LoadingIndicator />
      <div className={styles.status}>{status}</div>
    </div>
  );
}

LoadingOverlay.propTypes = {
  status: PropTypes.string.isRequired
};

export default LoadingOverlay;
